import { render } from "./AdvertisementTop.vue?vue&type=template&id=26c1ed04&scoped=true"
const script = {}

import "./AdvertisementTop.vue?vue&type=style&index=0&id=26c1ed04&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26c1ed04"]])

export default __exports__